import { configureStore } from '@reduxjs/toolkit';
import { Reducers as rootReducer } from 'src/redux/reducers';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import CryptoJS from 'crypto-js';
import createTransform from 'redux-persist/es/createTransform';
import config from 'src/config/config';

const middleware = thunk;

const { API_BASE_URL, UI_BASE_URL } = config;

const encryptionKey = API_BASE_URL + UI_BASE_URL;
const encryptTransform = createTransform(
	// transform state on the way to being serialized and persisted
	(inboundState) => {
		const ciphertext = CryptoJS.AES.encrypt(
			JSON.stringify(inboundState),
			encryptionKey
		).toString();
		return ciphertext;
	},
	// transform state being rehydrated
	(outboundState) => {
		const bytes = CryptoJS.AES.decrypt(outboundState, encryptionKey);
		return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
	}
);

const persistConfig = {
	key: 'root',
	storage,
	transforms: [encryptTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const devType = process.env.REACT_APP_DOMAIN_TYPE;
const devType = 'production';

let devTools = true; // By default, enable Redux DevTools

if (devType === 'production' || devType === 'dev' || devType === 'preprod') {
	// If DEV_TYPE is set to 'production', disable Redux DevTools
	devTools = false;
}

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore specific actions that are non-serializable
				ignoredActions: ['persist/PERSIST'],
			},
		}).concat(middleware),
	devTools: devTools
		? window.__REDUX_DEVTOOLS_EXTENSION__ &&
		  window.__REDUX_DEVTOOLS_EXTENSION__()
		: false,
});

export const persistor = persistStore(store);
